import styled from 'styled-components'

export const Container =  styled.div`
    display: flex;
    gap: 30px;
    margin: 30px;
    padding: 40px;
    background-color: #ffffff;
    border-radius: 8px;

    @media(max-width: 1100px) {
        flex-direction: column-reverse;
    }
`

export const ContainerCards = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 30px;

    @media(max-width: 1100px) {
        flex-direction: row;
    }
`